import r from "./isObject.js";
import { hasEnumBug as o } from "./_setup.js";
import t from "./_collectNonEnumProps.js";
function s(s) {
  if (!r(s)) return [];
  var e = [];
  for (var f in s) e.push(f);
  return o && t(s, e), e;
}
export { s as default };